module.exports = __webpack_public_path__ + "static/media/bolso (27).20667268.jpg";